<div class="form-holder">
  <div class="safe-area">

    <h1 *ngIf="votingType == 'resolution' || votingType == 'live'" id="title">{{'POLL-PLANNED.RESOLUTION' | translate}}
    </h1>
    <div *ngIf="votingType == 'list'" class="flex flex-row" style="margin-bottom: 30px;">
      <img src="assets/list_icon.svg" class="global-icon" />
      <div class="flex flex-column" style="margin-left: 20px;">
        <p class="dark-blue text-md no-margin">Élection {{answers.round + 1}}</p>
        <h1 id="title" class="dark-blue text-lg bold">{{titles[answers.round]}}</h1>
      </div>
    </div>
    <a href="{{blockchainLink}}" target="_blank" rel="noopener noreferrer" *ngIf="votingType == 'list' && displayBlockchain" class="blockchain-link">
      <img src="assets/global.svg" class="global-icon" /> {{'POLL-PLANNED.POLL-BLOCKCHAIN' | translate}}
    </a>
    <div class="container-answers" *ngIf="isElection">
      <ng-container *ngIf="votingType == 'list'">
        <ng-container *ngFor="let subject of subjects, let parent = index">
          <div class="container-candidate flex flex-row w-100p mt-10">
            <!-- <div class="left-block block"></div> TODO Add image if image, dont display if not-->
            <div class="block dark-blue mb-10 align-items-end" style="font-weight: 900;"><span
                *ngIf="parent + 1 != subjects.length" style="font-weight: normal; margin-right: 5px;">Liste :
              </span>{{translateAnswer(subject)}}</div>
          </div>
          <ng-container *ngFor="let answer of displayedAnswers[parent]; let index = index">
            <div class="container-candidate flex flex-row w-100p content-between mb-10">
              <div class="left-block block dark-blue">{{index + 1}}.</div>
              <img *ngIf="answer.startsWith('M.')" src="assets/man-icon.svg" class="global-icon" />
              <img *ngIf="answer.startsWith('Mme')" src="assets/woman-icon.svg" class="global-icon" />
              <div class="right-block block dark-blue w-80p">{{answer}}</div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>